/** Dias da semana (1 = segunda … 7 = domingo), alinhado ao backend. */
export const SCHEDULE_WEEKDAYS = [
  { value: 1, label: "Seg" },
  { value: 2, label: "Ter" },
  { value: 3, label: "Qua" },
  { value: 4, label: "Qui" },
  { value: 5, label: "Sex" },
  { value: 6, label: "Sáb" },
  { value: 7, label: "Dom" },
];

export const SCHEDULE_TIMEZONE_OPTIONS = [
  { value: "America/Sao_Paulo", label: "Brasília (UTC−3)" },
  { value: "America/Manaus", label: "Manaus (UTC−4)" },
  { value: "America/Fortaleza", label: "Fortaleza (UTC−3)" },
  { value: "America/Recife", label: "Recife (UTC−3)" },
  { value: "America/Cuiaba", label: "Cuiabá (UTC−4)" },
  { value: "America/Porto_Velho", label: "Porto Velho (UTC−4)" },
  { value: "America/Bahia", label: "Bahia (UTC−3)" },
  { value: "America/Belem", label: "Belém (UTC−3)" },
  { value: "America/Rio_Branco", label: "Rio Branco (UTC−5)" },
];

export const DEFAULT_SCHEDULE_BUSINESS_HOURS = {
  timezone: "America/Sao_Paulo",
  weekdays: [1, 2, 3, 4, 5],
  start: "08:00",
  end: "18:00",
};

export const SCHEDULE_RUN_WINDOW_MODES = [
  {
    value: "24h",
    label: "24 horas por dia",
    helper: "A regra pode disparar a qualquer momento, todos os dias.",
  },
  {
    value: "business_hours",
    label: "Apenas horário comercial",
    helper: "Segunda a sexta, das 08:00 às 18:00 (no fuso escolhido).",
  },
  {
    value: "defined_schedule",
    label: "Horário definido",
    helper: "Escolha os dias da semana e o intervalo em que a regra pode rodar.",
  },
];

/** Chaves de meta de agendamento (não são filtros de lead). */
export const SCHEDULE_CONDITION_META_KEYS = [
  "schedule_interval",
  "schedule_run_window",
  "schedule_apply_all",
  "schedule_include_closed",
  "schedule_confirm_wide",
];

export function isScheduleConditionMetaKey(key) {
  return SCHEDULE_CONDITION_META_KEYS.includes(key);
}

export function toTimeInputValue(hm) {
  const s = String(hm || "").trim();
  if (!s) return "08:00";
  const parts = s.split(":");
  const h = String(parseInt(parts[0], 10) || 0).padStart(2, "0");
  const m = String(parseInt(parts[1] ?? "0", 10) || 0).padStart(2, "0");
  return `${h}:${m}`;
}

export function normalizeScheduleRunWindow(raw) {
  if (!raw || typeof raw !== "object") {
    return { mode: "24h" };
  }
  const mode = ["24h", "business_hours", "defined_schedule"].includes(raw.mode)
    ? raw.mode
    : "24h";
  if (mode === "24h") return { mode: "24h" };

  const timezone =
    typeof raw.timezone === "string" && raw.timezone.trim()
      ? raw.timezone.trim()
      : DEFAULT_SCHEDULE_BUSINESS_HOURS.timezone;

  if (mode === "business_hours") {
    return {
      mode: "business_hours",
      timezone,
      weekdays: [...DEFAULT_SCHEDULE_BUSINESS_HOURS.weekdays],
      start: DEFAULT_SCHEDULE_BUSINESS_HOURS.start,
      end: DEFAULT_SCHEDULE_BUSINESS_HOURS.end,
    };
  }

  const weekdays = Array.isArray(raw.weekdays)
    ? raw.weekdays.map((n) => Number(n)).filter((n) => n >= 1 && n <= 7)
    : [...DEFAULT_SCHEDULE_BUSINESS_HOURS.weekdays];

  return {
    mode: "defined_schedule",
    timezone,
    weekdays: weekdays.length ? [...new Set(weekdays)].sort((a, b) => a - b) : [...DEFAULT_SCHEDULE_BUSINESS_HOURS.weekdays],
    start:
      typeof raw.start === "string" && raw.start.trim()
        ? raw.start.trim()
        : DEFAULT_SCHEDULE_BUSINESS_HOURS.start,
    end:
      typeof raw.end === "string" && raw.end.trim()
        ? raw.end.trim()
        : DEFAULT_SCHEDULE_BUSINESS_HOURS.end,
  };
}

export function formatScheduleRunWindowLabel(raw) {
  const w = normalizeScheduleRunWindow(raw);
  if (w.mode === "24h") return "24 horas por dia";
  if (w.mode === "business_hours") {
    return `Horário comercial (${w.start}–${w.end})`;
  }
  const days = (w.weekdays || [])
    .map((d) => SCHEDULE_WEEKDAYS.find((x) => x.value === d)?.label || d)
    .join(", ");
  return `${days || "—"} · ${w.start}–${w.end}`;
}

export function defaultScheduleRunWindow() {
  return { mode: "24h" };
}
